// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─────────────────────────────────────────────────────────────
   /projects in the shape of the catalog browse pages:
   category rail | project cards | detail drawer.

   The page grid, rail, header band, main column and drawer shell are reused
   from ../catalog/CatalogBrowseLayout.module.css. This file holds only what is
   specific to projects.

   Colours and geometry come from ../../styles/curioTokens.css. The card grid
   also inherits the --catalogBrowseCard* variables declared on \`.page\` in the
   catalog layout, so gaps, padding and the column width change on every
   browse page at once.
   ───────────────────────────────────────────────────────────── */

/* The card area owns the scroll so the header stays put. Same
   effect as the catalog's card grid, without pinning a viewport calc that
   breaks whenever the header's height changes. The scrollbar treatment is the
   catalog's, driven by the same inherited variables — the two pages used to
   scroll with visibly different bars. */
.x3_P43sqXHjrIr9CbEj8 {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: var(--catalogBrowseCardGridPadding, 16px);
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22))
    var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));
}

.x3_P43sqXHjrIr9CbEj8::-webkit-scrollbar {
  width: 6px;
}

.x3_P43sqXHjrIr9CbEj8::-webkit-scrollbar-track {
  background: var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));
  border-radius: 3px;
  margin: 4px 0;
}

.x3_P43sqXHjrIr9CbEj8::-webkit-scrollbar-thumb {
  background: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22));
  border-radius: 3px;
  border: 1px solid transparent;
  background-clip: padding-box;
}

.x3_P43sqXHjrIr9CbEj8::-webkit-scrollbar-thumb:hover {
  background: var(--catalogBrowseCardGridScrollbarThumbHover, rgba(30, 31, 35, 0.35));
  background-clip: padding-box;
}

/* The catalogs' column rule, from the same variable. */
.H1rOrj29s71ejsfxPd9Y {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(var(--catalogBrowseCardMinWidth, 220px), 1fr));
  gap: var(--catalogBrowseCardGridGap, 16px);
  /* Pack rows to the top so a short filtered list does not stretch. */
  align-content: start;
}

.fgwhhXBnOkeYjq0ZMMti {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nzbhNk31B5KV8QW6fM1u {
  display: flex;
  gap: 4px;
  flex-shrink: 0;
}

/* Sits beside the sort at the end of the header's intro row, so it takes the
   sort's height and corner. */
.enA8aTrowaFFY9CBwnop {
  height: 28px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  background: transparent;
  color: var(--curio-text-secondary);
  padding: 0 12px;
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
}

.enA8aTrowaFFY9CBwnop:hover:not(.wfzXyO2lqcCfDtxMyc2Q) {
  background: var(--curio-page-bg);
}

.wfzXyO2lqcCfDtxMyc2Q {
  background: var(--curio-top-bar-bg);
  border-color: var(--curio-top-bar-bg);
  color: var(--curio-card-bg);
}

/* ── Project cards ──

   The selection language is lifted from .card / .cardActive in
   ../catalog/CatalogBrowseLayout.module.css so a picked dataflow reads exactly
   like a picked catalog item: a raised shadow plus a border in the item's own
   colour. On the catalog pages that colour carries information — a dataset's
   format, a package's node category. A dataflow has neither, so here it is the
   one dataflow colour on every card; its categories are chips in the body. */

.tJiwCSe1sEoRHRIb9_MY {
  position: relative;
  height: 180px;
  border: 1.5px solid transparent;
  border-radius: 10px;
  background: var(--curio-card-bg);
  box-shadow: var(--curio-shadow-browse-card);
  overflow: hidden;
  cursor: pointer;
  outline: none;
  box-sizing: border-box;
  transition: box-shadow 0.15s, border-color 0.15s;
  /* Same top-down order as the catalog browse cards: accent strip, then the
     title block, then the artwork fills whatever height is left. The title used
     to sit at the bottom over a gradient, which read nothing like the other
     browse pages. */
  display: flex;
  flex-direction: column;
}

/* One colour for every dataflow. The catalog pages key a card's colour to
   one thing (a dataset's format, a package's node category); a dataflow's
   categories are many and are shown as chips, so a per-project accent would
   be decoration that read as information. The thumbnail below still colours
   its nodes by type. */
.viWVzyx5h85AiJ_aMepD {
  min-height: 28px;
  display: flex;
  align-items: center;
  padding: 3px 12px;
  flex-shrink: 0;
  background: var(--curio-kind-dataflow-fg);
}

.z3Xu269dgbCwPtHSje9q {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 14px 8px;
  flex-shrink: 0;
}

/* Matches .cardTitle / .publisher on the catalog browse cards. */
.ZoTtbUICto_9VIrfMYm5 {
  font-size: var(--curio-font-size-md);
  font-weight: 700;
  line-height: 1.3;
  color: var(--curio-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.Si4A_hgmueD7EtftuhNW {
  font-size: var(--curio-font-size-xs);
  color: var(--curio-text-meta);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Source and topic, one line: the rail has the rest. */
.WQvKECHL4oKrzEcTnQQf {
  display: flex;
  gap: var(--catalogBrowseCardTagGap, 5px);
  margin-top: 3px;
  overflow: hidden;
  flex-wrap: nowrap;
}

.WQvKECHL4oKrzEcTnQQf > * {
  flex-shrink: 0;
}

.K8Oi4shV1KExOmp02S_C {
  position: relative;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

.tJiwCSe1sEoRHRIb9_MY:hover,
.tJiwCSe1sEoRHRIb9_MY:focus-visible {
  box-shadow: var(--curio-shadow-browse-card-raised);
}

.cY3wWgfnrSzOUZXPnDcm {
  box-shadow: var(--curio-shadow-browse-card-raised);
  border-color: var(--curio-kind-dataflow-fg);
}

/* ── List view ──

   The Grid/List switch used to change only the container, so "List" rendered a
   single column of full 180px grid cards. In list view the same card turns on
   its side: the coloured strip becomes a leading block that keeps the kind
   label and revision badge, the title block takes the remaining width, and the
   thumbnail shrinks to a trailing tile. Nothing is hidden, so the two views
   carry the same information. */

.ZDsUiayOOCj7onnK4r93 {
  height: 56px;
  flex-direction: row;
  align-items: stretch;
}

.ZDsUiayOOCj7onnK4r93 .viWVzyx5h85AiJ_aMepD {
  width: 168px;
  min-height: 0;
  flex-shrink: 0;
  padding: 0 12px;
}

.ZDsUiayOOCj7onnK4r93 .z3Xu269dgbCwPtHSje9q {
  flex: 1;
  min-width: 0;
  justify-content: center;
  padding: 0 14px;
}

.ZDsUiayOOCj7onnK4r93 .K8Oi4shV1KExOmp02S_C {
  flex: 0 0 120px;
  min-height: 0;
}

/* Detail drawer: only the projects-specific action buttons live here. The rest
   of the drawer is ../catalog/CatalogBrowseDrawerBody, shared with both
   catalogs, so a layout change there necessarily lands on this page too. */

/* Two columns: Rename, Edit categories, Duplicate and Delete do not fit one
   320px row. */
.IS6gqIFxuaF_u14lZr8g {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
}

/* Secondary action in the detail drawer, sitting under the dark primary. */
.SzmMRljjM3Kb_2p2ikKj {
  flex: 1;
  height: 36px;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  background: transparent;
  color: var(--curio-text-primary);
  font-family: inherit;
  font-size: var(--curio-font-size-sm);
  font-weight: 600;
  cursor: pointer;
}

.SzmMRljjM3Kb_2p2ikKj:hover {
  background: #fafafa;
  border-color: var(--curio-border-strong);
}

.F0LH_vLg8H1EAKwgLh29 {
  color: var(--curio-danger-text);
}

.F0LH_vLg8H1EAKwgLh29:hover {
  background: var(--curio-danger-bg);
  border-color: var(--curio-danger-border);
}
`, "",{"version":3,"sources":["webpack://./src/pages/projects/ProjectsBrowseLayout.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;kEAYkE;;AAElE;;;;wCAIwC;AACxC;EACE,OAAO;EACP,aAAa;EACb,gBAAgB;EAChB,kDAAkD;EAClD,wBAAwB;EACxB,qBAAqB;EACrB;sEACoE;AACtE;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,8EAA8E;EAC9E,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,mFAAmF;EACnF,4BAA4B;AAC9B;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,8FAA8F;EAC9F,0CAA0C;EAC1C,oEAAoE;EACpE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;AAChB;;AAEA;8BAC8B;AAC9B;EACE,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;EACvB,kCAAkC;EAClC,eAAe;EACf,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;;;;;;6EAO6E;;AAE7E;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gCAAgC;EAChC,2CAA2C;EAC3C,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gDAAgD;EAChD;;;oBAGkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;;;uBAIuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,sBAAsB;EACtB,cAAc;AAChB;;AAEA,iEAAiE;AACjE;EACE,oCAAoC;EACpC,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,6BAA6B;EAC7B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,wCAAwC;EACxC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;;EAEE,kDAAkD;AACpD;;AAEA;EACE,kDAAkD;EAClD,2CAA2C;AAC7C;;AAEA;;;;;;;gCAOgC;;AAEhC;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;;2EAE2E;;AAE3E;eACe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,QAAQ;AACV;;AAEA,2EAA2E;AAC3E;EACE,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,qCAAqC;EACrC,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C","sourcesContent":["/* ─────────────────────────────────────────────────────────────\n   /projects in the shape of the catalog browse pages:\n   category rail | project cards | detail drawer.\n\n   The page grid, rail, header band, main column and drawer shell are reused\n   from ../catalog/CatalogBrowseLayout.module.css. This file holds only what is\n   specific to projects.\n\n   Colours and geometry come from ../../styles/curioTokens.css. The card grid\n   also inherits the --catalogBrowseCard* variables declared on `.page` in the\n   catalog layout, so gaps, padding and the column width change on every\n   browse page at once.\n   ───────────────────────────────────────────────────────────── */\n\n/* The card area owns the scroll so the header stays put. Same\n   effect as the catalog's card grid, without pinning a viewport calc that\n   breaks whenever the header's height changes. The scrollbar treatment is the\n   catalog's, driven by the same inherited variables — the two pages used to\n   scroll with visibly different bars. */\n.cardScroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  padding: var(--catalogBrowseCardGridPadding, 16px);\n  scrollbar-gutter: stable;\n  scrollbar-width: thin;\n  scrollbar-color: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22))\n    var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));\n}\n\n.cardScroll::-webkit-scrollbar {\n  width: 6px;\n}\n\n.cardScroll::-webkit-scrollbar-track {\n  background: var(--catalogBrowseCardGridScrollbarTrack, rgba(30, 31, 35, 0.06));\n  border-radius: 3px;\n  margin: 4px 0;\n}\n\n.cardScroll::-webkit-scrollbar-thumb {\n  background: var(--catalogBrowseCardGridScrollbarThumb, rgba(30, 31, 35, 0.22));\n  border-radius: 3px;\n  border: 1px solid transparent;\n  background-clip: padding-box;\n}\n\n.cardScroll::-webkit-scrollbar-thumb:hover {\n  background: var(--catalogBrowseCardGridScrollbarThumbHover, rgba(30, 31, 35, 0.35));\n  background-clip: padding-box;\n}\n\n/* The catalogs' column rule, from the same variable. */\n.cardGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(var(--catalogBrowseCardMinWidth, 220px), 1fr));\n  gap: var(--catalogBrowseCardGridGap, 16px);\n  /* Pack rows to the top so a short filtered list does not stretch. */\n  align-content: start;\n}\n\n.cardList {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.viewSwitch {\n  display: flex;\n  gap: 4px;\n  flex-shrink: 0;\n}\n\n/* Sits beside the sort at the end of the header's intro row, so it takes the\n   sort's height and corner. */\n.viewButton {\n  height: 28px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  background: transparent;\n  color: var(--curio-text-secondary);\n  padding: 0 12px;\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n}\n\n.viewButton:hover:not(.viewButtonActive) {\n  background: var(--curio-page-bg);\n}\n\n.viewButtonActive {\n  background: var(--curio-top-bar-bg);\n  border-color: var(--curio-top-bar-bg);\n  color: var(--curio-card-bg);\n}\n\n/* ── Project cards ──\n\n   The selection language is lifted from .card / .cardActive in\n   ../catalog/CatalogBrowseLayout.module.css so a picked dataflow reads exactly\n   like a picked catalog item: a raised shadow plus a border in the item's own\n   colour. On the catalog pages that colour carries information — a dataset's\n   format, a package's node category. A dataflow has neither, so here it is the\n   one dataflow colour on every card; its categories are chips in the body. */\n\n.card {\n  position: relative;\n  height: 180px;\n  border: 1.5px solid transparent;\n  border-radius: 10px;\n  background: var(--curio-card-bg);\n  box-shadow: var(--curio-shadow-browse-card);\n  overflow: hidden;\n  cursor: pointer;\n  outline: none;\n  box-sizing: border-box;\n  transition: box-shadow 0.15s, border-color 0.15s;\n  /* Same top-down order as the catalog browse cards: accent strip, then the\n     title block, then the artwork fills whatever height is left. The title used\n     to sit at the bottom over a gradient, which read nothing like the other\n     browse pages. */\n  display: flex;\n  flex-direction: column;\n}\n\n/* One colour for every dataflow. The catalog pages key a card's colour to\n   one thing (a dataset's format, a package's node category); a dataflow's\n   categories are many and are shown as chips, so a per-project accent would\n   be decoration that read as information. The thumbnail below still colours\n   its nodes by type. */\n.cardStrip {\n  min-height: 28px;\n  display: flex;\n  align-items: center;\n  padding: 3px 12px;\n  flex-shrink: 0;\n  background: var(--curio-kind-dataflow-fg);\n}\n\n.cardBody {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  padding: 10px 14px 8px;\n  flex-shrink: 0;\n}\n\n/* Matches .cardTitle / .publisher on the catalog browse cards. */\n.cardTitle {\n  font-size: var(--curio-font-size-md);\n  font-weight: 700;\n  line-height: 1.3;\n  color: var(--curio-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.cardSub {\n  font-size: var(--curio-font-size-xs);\n  color: var(--curio-text-meta);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n/* Source and topic, one line: the rail has the rest. */\n.cardTags {\n  display: flex;\n  gap: var(--catalogBrowseCardTagGap, 5px);\n  margin-top: 3px;\n  overflow: hidden;\n  flex-wrap: nowrap;\n}\n\n.cardTags > * {\n  flex-shrink: 0;\n}\n\n.cardThumbnail {\n  position: relative;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n}\n\n.card:hover,\n.card:focus-visible {\n  box-shadow: var(--curio-shadow-browse-card-raised);\n}\n\n.cardActive {\n  box-shadow: var(--curio-shadow-browse-card-raised);\n  border-color: var(--curio-kind-dataflow-fg);\n}\n\n/* ── List view ──\n\n   The Grid/List switch used to change only the container, so \"List\" rendered a\n   single column of full 180px grid cards. In list view the same card turns on\n   its side: the coloured strip becomes a leading block that keeps the kind\n   label and revision badge, the title block takes the remaining width, and the\n   thumbnail shrinks to a trailing tile. Nothing is hidden, so the two views\n   carry the same information. */\n\n.cardRow {\n  height: 56px;\n  flex-direction: row;\n  align-items: stretch;\n}\n\n.cardRow .cardStrip {\n  width: 168px;\n  min-height: 0;\n  flex-shrink: 0;\n  padding: 0 12px;\n}\n\n.cardRow .cardBody {\n  flex: 1;\n  min-width: 0;\n  justify-content: center;\n  padding: 0 14px;\n}\n\n.cardRow .cardThumbnail {\n  flex: 0 0 120px;\n  min-height: 0;\n}\n\n/* Detail drawer: only the projects-specific action buttons live here. The rest\n   of the drawer is ../catalog/CatalogBrowseDrawerBody, shared with both\n   catalogs, so a layout change there necessarily lands on this page too. */\n\n/* Two columns: Rename, Edit categories, Duplicate and Delete do not fit one\n   320px row. */\n.detailButtonRow {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 8px;\n}\n\n/* Secondary action in the detail drawer, sitting under the dark primary. */\n.secondaryButton {\n  flex: 1;\n  height: 36px;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  background: transparent;\n  color: var(--curio-text-primary);\n  font-family: inherit;\n  font-size: var(--curio-font-size-sm);\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.secondaryButton:hover {\n  background: #fafafa;\n  border-color: var(--curio-border-strong);\n}\n\n.dangerButton {\n  color: var(--curio-danger-text);\n}\n\n.dangerButton:hover {\n  background: var(--curio-danger-bg);\n  border-color: var(--curio-danger-border);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardScroll": `x3_P43sqXHjrIr9CbEj8`,
	"cardGrid": `H1rOrj29s71ejsfxPd9Y`,
	"cardList": `fgwhhXBnOkeYjq0ZMMti`,
	"viewSwitch": `nzbhNk31B5KV8QW6fM1u`,
	"viewButton": `enA8aTrowaFFY9CBwnop`,
	"viewButtonActive": `wfzXyO2lqcCfDtxMyc2Q`,
	"card": `tJiwCSe1sEoRHRIb9_MY`,
	"cardStrip": `viWVzyx5h85AiJ_aMepD`,
	"cardBody": `z3Xu269dgbCwPtHSje9q`,
	"cardTitle": `ZoTtbUICto_9VIrfMYm5`,
	"cardSub": `Si4A_hgmueD7EtftuhNW`,
	"cardTags": `WQvKECHL4oKrzEcTnQQf`,
	"cardThumbnail": `K8Oi4shV1KExOmp02S_C`,
	"cardActive": `cY3wWgfnrSzOUZXPnDcm`,
	"cardRow": `ZDsUiayOOCj7onnK4r93`,
	"detailButtonRow": `IS6gqIFxuaF_u14lZr8g`,
	"secondaryButton": `SzmMRljjM3Kb_2p2ikKj`,
	"dangerButton": `F0LH_vLg8H1EAKwgLh29`
};
export default ___CSS_LOADER_EXPORT___;
